<template>
    <star-rating 
        :rating="rating"
        :increment=".5"
        :read-only="true"
        :show-rating="false"
        :star-size="15"
        active-color="#000"
        inactive-color="#DDE2E6"
    />
</template>

<script>
import StarRating from 'vue-star-rating';

export default {
    components: {
        StarRating
    },
    props: {
        rating: {
            type: Number
        }
    }
};
</script>
